import { createRef } from 'react';
import { CellContent } from './CellContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const RowCellContent = ({
  content,
  rowIndex,
  columnIndex,
  disabled,
  readOnly,
  ...props
}) => {
  const itemData = props.itemData;
  const {
    updateControlRefs,
    getRowIdentifier,
    columns
  } = itemData;
  const column = columns[columnIndex];
  const rowKey = getRowIdentifier(rowIndex);
  const columnKey = column?.key;
  if (typeof content === 'function') {
    const ref = /*#__PURE__*/createRef();
    updateControlRefs(columnKey, rowKey, ref);
    let focusCellContent = itemData.preference?.scrollPosition?.editOnFocus;
    if (focusCellContent) {
      const cellToFocus = itemData.preference?.scrollPosition?.cell;
      const rowIndex = cellToFocus?.rowIndex;
      const colIndex = cellToFocus?.colIndex;
      const colKey = colIndex !== undefined ? itemData.columns[colIndex].key : '';
      focusCellContent = rowIndex === rowIndex && colKey === columnKey;
    }
    return /*#__PURE__*/_jsx(CellContent, {
      itemData: itemData,
      rowIndex: rowIndex,
      columnKey: columnKey,
      className: column.cellContainerClassName,
      style: column.cellContainerStyle,
      focus: focusCellContent,
      contentRef: ref,
      children: content(columnIndex, rowIndex, columnKey, ref, disabled, readOnly)
    });
  }
  return /*#__PURE__*/_jsx(CellContent, {
    itemData: itemData,
    rowIndex: rowIndex,
    columnKey: columnKey,
    className: column.cellContainerClassName,
    style: column.cellContainerStyle,
    children: content
  });
};
//# sourceMappingURL=RowCellContent.js.map